module.exports = __webpack_public_path__ + "static/media/country_id.9510d483.webp";